var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    rx: 1,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gb_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    rx: 1,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A17A7",
    d: "M0 0h14v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.337 6.666l-4.724 3.186.746 1.105 5.974-4.03v3.739h3.334V6.928l5.974 4.03.746-1.106-4.724-3.186H14V3.333h-3.337L15.387.146 14.64-.959l-5.974 4.03V-.667H5.333V3.07L-.64-.96-1.387.146l4.724 3.187H0v3.333h3.337z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.334 3.166L15.667-1M10.006 6.85l5.677 3.826M4.003 3.155L-1.92-.835M4.645 6.803l-6.564 4.353",
    stroke: "#DB1F35",
    strokeWidth: 0.333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6h6v4h2V6h6V4H8V0H6v4H0v2z",
    fill: "#E6273E"
  }))));
}
export default SvgGb;